import React, { Component } from 'react'

import Header from '../header'
import anonymus from '../../../../../img/anonymus.jpg'
import cover from '../../../../../img/cover.png'

class HeroOrizzontale extends Component {
	constructor(props) {
		super(props)
		this.state = {
			opacity: 0,
			opacityP: 0,
			cover: cover,
			coverType: '',
			effettoCover: '',
			coloreCover: ''
		}
	}

	componentDidMount() {

		this.setState({
			cover: this.props.sito.cover || cover,
			coverType: this.props.sito.coverType || 'image/png',
			effettoCover: this.props.sito.effettoCover || 'nessuno',
			coloreCover: this.props.sito.coloreCover || '#333333'
		})

	}

	imgLoaded() {
		this.setState({ opacity: 1 })
	}
	prfLoaded() {
		this.setState({ opacityP: 1 })
	}

	render() {

		return (
			<div
				id="top"
				className="uk-flex uk-flex-center uk-flex-middle uk-light uk-position-relative"
				data-uk-height-viewport=""
				style={{ backgroundColor: this.state.coloreCover, overflow: 'hidden' }}
			>

				{
					this.state.coverType.includes('image') ?

						<img
							className={this.state.effettoCover !== 'nessuno' ? 'uk-blend-' + this.state.effettoCover : ''}
							onLoad={this.imgLoaded.bind(this)} src={this.state.cover} style={{
								top: 0,
								left: 0,
								position: 'absolute',
								objectFit: 'cover',
								objectPosition: 'center top',
								height: '100%',
								width: '100%',
								opacity: this.state.opacity,
								transition: 'opacity 0.8s',
								WebkitTransition: 'opacity 0.8s',
								msTransition: 'opacity 0.8s'
							}}
						/> :

						<video
							onCanPlay={this.imgLoaded.bind(this)}
							className={this.state.effettoCover !== 'nessuno' ? 'uk-blend-' + this.state.effettoCover : ''}
							loop
							muted
							playsInline
							data-uk-video="autoplay: inview"
							style={{
								top: 0,
								left: 0,
								position: 'absolute',
								objectFit: 'cover',
								objectPosition: 'center top',
								height: '100%',
								width: '100%',
								opacity: this.state.opacity,
								transition: 'opacity 0.8s',
								WebkitTransition: 'opacity 0.8s',
								msTransition: 'opacity 0.8s'
							}}>
							<source src={this.state.cover} type={this.state.coverType} />
						</video>
				}

				<Header logo={this.props.user.name} user={this.props.user.userId} />

				<div className="uk-text-center" style={{ zIndex: '2' }}>

					<img
						onLoad={this.prfLoaded.bind(this)}
						className="uk-border-circle"
						src={this.props.user.foto || anonymus}
						width="200"
						height="200"
						alt=""
						style={{
							border: '8px solid rgba(255,255,255,0.3)',
							opacity: this.state.opacityP,
							transition: 'opacity 0.3s',
							WebkitTransition: 'opacity 0.3s',
							msTransition: 'opacity 0.3s'
						}}
					/>

					<div className="uk-text-center uk-margin">
						<h2 className="uk-card-title uk-margin-remove uk-text-uppercase">{this.props.user.name}</h2>
						<p className="uk-margin-small uk-text-uppercase">{this.props.user.ruolo}</p>
					</div>

					<div className="uk-flex uk-flex-center" >
						{this.props.user.twitter &&
							<div className="uk-margin-small-left uk-margin-small-right">
								<a target="_blank" data-uk-icon="icon: twitter;ratio: 1" href={this.props.user.twitter} className="uk-icon-link uk-icon"></a>
							</div>
						}
						{this.props.user.instagram &&
							<div className="uk-margin-small-left uk-margin-small-right">
								<a target="_blank" data-uk-icon="icon: instagram;ratio: 1" href={this.props.user.instagram} className="uk-icon-link uk-icon"></a>
							</div>
						}
						{this.props.user.facebook &&
							<div target="_blank" className="uk-margin-small-left uk-margin-small-right">
								<a data-uk-icon="icon: facebook;ratio: 1" href={this.props.user.facebook} className="uk-icon-link uk-icon"></a>
							</div>
						}
						{this.props.user.web &&
							<div target="_blank" className="uk-margin-small-left uk-margin-small-right">
								<a data-uk-icon="icon: link;ratio: 1" href={this.props.user.web} className="uk-icon-link uk-icon"></a>
							</div>
						}

					</div>

				</div>
			</div>
		)
	}
}

export default HeroOrizzontale


// WEBPACK FOOTER //
// ./src/components/sito/temi/layoutorizzontale/hero/index.js